import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent implements OnInit {
	returnUrl: string;
	constructor(private route: ActivatedRoute, private router: Router) { }

	ngOnInit() {
		this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
	}

	apply() {
		location.href = 'profile/apply/key?returnUrl=' + this.returnUrl;
		//this.router.navigate(['profile/apply/key',this.returnUrl]);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/error/access-denied/access-denied.component.ts